import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { AuthButton } from '@/components/ui/AuthButton';

export default function NostalgiaDashboard() {
  const { isAuthenticated } = useAuth();

  const menuItems = [
    {
      title: 'Boards',
      description: 'Create and manage nostalgia boards',
      href: '/nostalgia/boards',
      icon: '📋',
      count: null,
    },
    {
      title: 'Library',
      description: 'Curated content (TV shows, snacks, etc.)',
      href: '/nostalgia/library',
      icon: '📚',
      count: null,
    },
    {
      title: 'Stickers',
      description: 'Decorative nostalgia stickers',
      href: '/nostalgia/stickers',
      icon: '🎨',
      count: null,
    },
    {
      title: 'Templates',
      description: 'Pre-designed board layouts',
      href: '/nostalgia/templates',
      icon: '📐',
      count: null,
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Header with Auth */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Nostalgia CRUD</h1>
            <p className="text-gray-500 mt-1">Manage Yaadein content</p>
          </div>
          <AuthButton />
        </div>

        {/* Auth Required Notice */}
        {!isAuthenticated && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
            <p className="text-yellow-800">
              <strong>Login required.</strong> Click the Login button above to authenticate and access CRUD operations.
            </p>
          </div>
        )}

        {/* Menu Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {menuItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={`block p-6 bg-white rounded-lg border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all ${
                !isAuthenticated ? 'opacity-60 pointer-events-none' : ''
              }`}
            >
              <div className="flex items-start gap-4">
                <span className="text-3xl">{item.icon}</span>
                <div className="flex-1">
                  <h2 className="text-lg font-semibold text-gray-900">{item.title}</h2>
                  <p className="text-sm text-gray-500 mt-1">{item.description}</p>
                </div>
                {item.count !== null && (
                  <span className="px-2 py-1 text-xs font-medium bg-gray-100 text-gray-600 rounded">
                    {item.count}
                  </span>
                )}
              </div>
            </Link>
          ))}
        </div>

        {/* Quick Links */}
        <div className="mt-8 pt-8 border-t">
          <h3 className="text-sm font-medium text-gray-500 mb-4">Quick Actions</h3>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/nostalgia/boards/new"
              className={`px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 ${
                !isAuthenticated ? 'opacity-60 pointer-events-none' : ''
              }`}
            >
              + New Board
            </Link>
            <Link
              to="/"
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
            >
              ← Back to Lab Home
            </Link>
          </div>
        </div>

        {/* API Info */}
        <div className="mt-8 p-4 bg-gray-100 rounded-lg">
          <h3 className="text-sm font-medium text-gray-700 mb-2">API Endpoints</h3>
          <code className="text-xs text-gray-600 block">
            Base: {import.meta.env.VITE_API_URL || 'http://localhost:7001'}/v1/nostalgia/
          </code>
        </div>
      </div>
    </div>
  );
}
